import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, createSlots as _createSlots } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 24 24",
  width: "15",
  height: "15"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M6 9l6 6 6-6" })
], -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("b", null, "5 MB.", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("b", null, "PNG, PDF, JPEG, BMP, HEIC, DOCX, DOC.", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SharedBack = _resolveComponent("SharedBack")!
  const _component_SharedUpload = _resolveComponent("SharedUpload")!
  const _component_SharedValidate = _resolveComponent("SharedValidate")!
  const _component_SharedDownload = _resolveComponent("SharedDownload")!
  const _component_UIButton = _resolveComponent("UIButton")!
  const _component_SharedCard = _resolveComponent("SharedCard")!

  return (_openBlock(), _createBlock(_component_SharedCard, {
    class: _normalizeClass(_ctx.b())
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.b('header'))
      }, [
        _createVNode(_component_SharedBack, { onClick: _ctx.handleBack }, null, 8, ["onClick"]),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.b('header-content'))
        }, [
          _createElementVNode("h3", {
            class: _normalizeClass(_ctx.b('header-title'))
          }, _toDisplayString(_ctx.$t("Загрузка документов")), 3),
          _createElementVNode("p", {
            class: _normalizeClass(_ctx.b('header-subtitle'))
          }, _toDisplayString(_ctx.$t("Список собран по ответам о вашей организации")), 3)
        ], 2)
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.b('upload'))
      }, [
        _createElementVNode("h5", {
          class: _normalizeClass(_ctx.b('title'))
        }, _toDisplayString(_ctx.$t("Загрузите подтверждающие документы*")), 3),
        _createElementVNode("p", {
          class: _normalizeClass(_ctx.b('upload-hint'))
        }, _toDisplayString(_ctx.$t(
            "Три группы, по шагам. Раскройте группу — под каждым документом написано, что именно подойдёт."
          )), 3),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.b('document-groups'))
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.documentGroups, (group) => {
            return (_openBlock(), _createElementBlock("section", {
              key: group.id,
              class: _normalizeClass(_ctx.b('document-group', { open: _ctx.openedGroup === group.id }))
            }, [
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(_ctx.b('document-group-header')),
                onClick: ($event: any) => (_ctx.handleGroupToggle(group.id))
              }, [
                _createElementVNode("span", {
                  class: _normalizeClass(_ctx.b('document-group-title'))
                }, _toDisplayString(_ctx.$t(group.title)), 3),
                _createElementVNode("span", {
                  class: _normalizeClass(_ctx.b('document-group-meta'))
                }, [
                  _createTextVNode(_toDisplayString(_ctx.displayedGroupCount(group)) + " / " + _toDisplayString(group.documents.length) + " ", 1),
                  _createElementVNode("span", {
                    class: _normalizeClass(
                  _ctx.b('document-group-chevron', {
                    open: _ctx.openedGroup === group.id,
                  })
                )
                  }, _hoisted_3, 2)
                ], 2)
              ], 10, _hoisted_1),
              _withDirectives(_createElementVNode("div", {
                class: _normalizeClass(_ctx.b('document-group-content'))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.documents, (documentItem) => {
                  return (_openBlock(), _createBlock(_component_SharedValidate, {
                    key: documentItem.name,
                    class: _normalizeClass(_ctx.b('document-row')),
                    field: documentItem.name,
                    value: _ctx.documents[documentItem.name].id,
                    "is-validate": _ctx.isValidate && Boolean(documentItem.required)
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_SharedUpload, {
                        class: _normalizeClass(_ctx.b('document-row-upload')),
                        document: _ctx.documents[documentItem.name],
                        "is-readonly": _ctx.isReadonly,
                        "is-loading": _ctx.isLoading,
                        "is-preview": false,
                        "success-icon": _ctx.documentSuccessIcon,
                        "remove-view": "kyb-document",
                        "is-error": 
                  _ctx.isValidate &&
                  Boolean(documentItem.required) &&
                  !_ctx.documents[documentItem.name].id
                ,
                        onUpload: _ctx.handleUploadFile,
                        onRemove: _ctx.handleRemoveFile
                      }, {
                        label: _withCtx(() => [
                          _createElementVNode("span", {
                            class: _normalizeClass(_ctx.b('document-row-copy'))
                          }, [
                            _createElementVNode("span", {
                              class: _normalizeClass(_ctx.b('document-row-title'))
                            }, [
                              _createTextVNode(_toDisplayString(_ctx.$t(documentItem.title)) + " ", 1),
                              (documentItem.required)
                                ? (_openBlock(), _createElementBlock("b", _hoisted_4, "*"))
                                : _createCommentVNode("", true)
                            ], 2),
                            _createElementVNode("span", {
                              class: _normalizeClass(_ctx.b('document-row-description'))
                            }, _toDisplayString(_ctx.$t(documentItem.description)), 3)
                          ], 2),
                          _createElementVNode("span", {
                            class: _normalizeClass(
                      _ctx.b('document-row-action', {
                        success: Boolean(_ctx.documents[documentItem.name].id),
                      })
                    )
                          }, _toDisplayString(_ctx.documents[documentItem.name].id
                        ? _ctx.$t("Загружено")
                        : _ctx.$t("Загрузить")), 3)
                        ]),
                        _: 2
                      }, 1032, ["class", "document", "is-readonly", "is-loading", "success-icon", "is-error", "onUpload", "onRemove"])
                    ]),
                    _: 2
                  }, 1032, ["class", "field", "value", "is-validate"]))
                }), 128))
              ], 2), [
                [_vShow, _ctx.openedGroup === group.id]
              ])
            ], 2))
          }), 128))
        ], 2)
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.b('download'))
      }, [
        _createElementVNode("h5", {
          class: _normalizeClass(_ctx.b('title'))
        }, _toDisplayString(_ctx.$t("Скачайте и подпишите соглашения*")), 3),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.b('download-groups'))
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.b('download-group'))
          }, [
            _createVNode(_component_SharedDownload, { document: _ctx.displayedQuestionnaireOfALegalEntity }, {
              label: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("Анкета")) + " ", 1),
                _hoisted_5,
                _createTextVNode(" " + _toDisplayString(_ctx.$t("юридического лица")), 1)
              ]),
              _: 1
            }, 8, ["document"]),
            _createVNode(_component_SharedValidate, {
              field: "kyb-documents-document",
              value: _ctx.documents['kyb-documents-document'].id,
              "is-validate": _ctx.isValidate,
              "is-center": true
            }, {
              default: _withCtx(() => [
                _createVNode(_component_SharedUpload, {
                  class: _normalizeClass(_ctx.b('download-upload')),
                  document: _ctx.documents['kyb-documents-document'],
                  "is-readonly": _ctx.isReadonly,
                  isCenter: true,
                  "is-loading": _ctx.isLoading,
                  "is-error": _ctx.isValidate && !_ctx.documents['kyb-documents-document'].id,
                  onUpload: _ctx.handleUploadFile,
                  onRemove: _ctx.handleRemoveFile
                }, {
                  label: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("Подписанное")) + " ", 1),
                    _hoisted_6,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t("соглашение")), 1)
                  ]),
                  _: 1
                }, 8, ["class", "document", "is-readonly", "is-loading", "is-error", "onUpload", "onRemove"])
              ]),
              _: 1
            }, 8, ["value", "is-validate"])
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.b('download-group'))
          }, [
            _createVNode(_component_SharedDownload, { document: _ctx.displayedBrokerageAgreement }, {
              label: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("Брокерский")) + " ", 1),
                _hoisted_7,
                _createTextVNode(" " + _toDisplayString(_ctx.$t("договор")), 1)
              ]),
              _: 1
            }, 8, ["document"]),
            _createVNode(_component_SharedValidate, {
              field: "kyc-personal-documents-broker",
              value: _ctx.documents['kyb-documents-broker'].id,
              "is-validate": _ctx.isValidate,
              "is-center": true
            }, {
              default: _withCtx(() => [
                _createVNode(_component_SharedUpload, {
                  class: _normalizeClass(_ctx.b('download-upload')),
                  document: _ctx.documents['kyb-documents-broker'],
                  "is-readonly": _ctx.isReadonly,
                  "is-loading": _ctx.isLoading,
                  isCenter: true,
                  "is-error": _ctx.isValidate && !_ctx.documents['kyb-documents-broker'].id,
                  onUpload: _ctx.handleUploadFile,
                  onRemove: _ctx.handleRemoveFile
                }, {
                  label: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("Подписанное")) + " ", 1),
                    _hoisted_8,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t("соглашение")), 1)
                  ]),
                  _: 1
                }, 8, ["class", "document", "is-readonly", "is-loading", "is-error", "onUpload", "onRemove"])
              ]),
              _: 1
            }, 8, ["value", "is-validate"])
          ], 2)
        ], 2)
      ], 2),
      (_ctx.isOtherShow)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(_ctx.b('other'))
          }, [
            _createElementVNode("h5", {
              class: _normalizeClass(_ctx.b('title'))
            }, _toDisplayString(_ctx.$t(
            "Пожалуйста, прикрепите иные документы для подтверждения вашей верификации"
          )), 3),
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.b('other-documents'))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.files, (file) => {
                return (_openBlock(), _createBlock(_component_SharedUpload, {
                  key: file.uuid,
                  class: _normalizeClass(_ctx.b('other-upload')),
                  document: file,
                  "is-upload": file.isUpload,
                  "is-remove": file.isRemove,
                  "is-readonly": _ctx.isReadonly,
                  "is-loading": _ctx.isLoading,
                  onRemove: _ctx.handleRemoveAdditionalFile
                }, _createSlots({ _: 2 }, [
                  (file.name)
                    ? {
                        name: "label",
                        fn: _withCtx(() => [
                          _createTextVNode(_toDisplayString(file.name), 1)
                        ]),
                        key: "0"
                      }
                    : undefined
                ]), 1032, ["class", "document", "is-upload", "is-remove", "is-readonly", "is-loading", "onRemove"]))
              }), 128)),
              (_ctx.isAddtionalUpload)
                ? (_openBlock(), _createBlock(_component_SharedUpload, {
                    key: 0,
                    class: _normalizeClass(_ctx.b('other-upload')),
                    document: _ctx.file,
                    "is-upload": _ctx.file.isUpload,
                    "is-readonly": _ctx.isReadonly,
                    "is-loading": _ctx.isLoading,
                    isCenter: true,
                    "is-label": false,
                    onUpload: _ctx.handleUploadAdditionalFile
                  }, null, 8, ["class", "document", "is-upload", "is-readonly", "is-loading", "onUpload"]))
                : _createCommentVNode("", true)
            ], 2)
          ], 2))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.b('file-info'))
      }, [
        _createElementVNode("p", {
          class: _normalizeClass(_ctx.b('file-info-text'))
        }, [
          _createTextVNode(_toDisplayString(_ctx.$t("Размер загружаемого файла — не более ")) + " ", 1),
          _hoisted_9
        ], 2),
        _createElementVNode("p", {
          class: _normalizeClass(_ctx.b('file-info-text'))
        }, [
          _createTextVNode(_toDisplayString(_ctx.$t("Поддерживаемые форматы: ")) + " ", 1),
          _hoisted_10
        ], 2)
      ], 2),
      _createVNode(_component_UIButton, {
        class: _normalizeClass(_ctx.b('continue')),
        label: "Продолжить",
        view: "main",
        disabled: _ctx.isContinueDisabled,
        onClick: _ctx.handleContinue
      }, null, 8, ["class", "disabled", "onClick"])
    ]),
    _: 1
  }, 8, ["class"]))
}